import React from "react";
const Q2 = () => {
  return (
    <div style={{ backgroundColor: "#Dbe6ea" }}>
      <div className="ans-bank">
        <div className="qta">What are Privacy Policy?</div>
        <p>
          Information submitted with an entry is subject to the Privacy Policy
          stated on the Bunk4Study website. Click here [link to privacy policy]
          to read the Privacy Policy. NOTE: a privacy policy might be optional.
          However, use of a privacy policy may be required based on the laws
          where you live or where your participants live, the type of promotion
          you’re running when using third-party platforms or features from
          social media channels. One benefit of including PrivacyPolicy
          information is that you make clear to your participants how you will
          use their information.
        </p>
      </div>
    </div>
  );
};

export default Q2;
